// eslint-disable-next-line import/no-cycle
import * as globalApi from '@/api/global'
import dynamicRoute from '@/components/OverLayout/components/custom-menu/utils/dynamicRoute/index'
import request from '@/utils/request'
import { Message } from 'element-ui'
import { flatFun } from '@/utils'

const permission = {
  state: {
    resourceList: [],
    subMenuList: [], // 左侧二级菜单栏目
    navMenus: [], // 左侧一级菜单栏目
    asynRouters: null,
    addRouters: [], // 动态路由数据
    isGetPermission: true, // 资源加载中
    pathnames: [], // 平台权限
    logoText: '',
    logo: '',
    tenantName: '',
    menus: {},
    allResource: [],
  },
  mutations: {
    SET_ALLRESOURCE: (state, allResource) => {
      state.allResource = allResource
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
    },
    SET_COMPANYNAME: (state, companyName) => {
      state.tenantName = companyName
    },
    SET_ASYN_ROUTERS: (state, routers) => {
      state.asynRouters = routers
    },
    SET_GET_IS_PERMISSION(state, flan) {
      state.isGetPermission = flan
    },
    SET_PLATFORM(state, pathnames) {
      state.pathnames = pathnames
    },
    // 左侧一级菜单栏目
    SET_NAV_MENU(state, navMenus) {
      state.navMenus = navMenus
    },
    SET_RESOURCE_LIST(state, resourceList) {
      state.resourceList = resourceList
    },
    SET_LOGO_OBJ: (state, data = {}) => {
      state.logoText =
        data.logoText ||
        'https://cdn.cheweijia.com/public/96c9b4f9b17e4257b5f3d54454072cb2.png'
      state.logo = data.logo || require('../../assets/img/logo.svg')
      // state.tenantName = data.tenantName || '约约'
      const link = document.getElementsByTagName('link')
      for (const i in link) {
        const li = link[i]
        if (li.rel === 'shortcut icon') {
          li.href = data.favicon

          li.type = ''

          li.type = 'image/x-icon'
          break
        }
      }
    },
    // // 左侧二级菜单栏目
    SET_DYNAMIC_ROUTE(state, subMenuList) {
      state.subMenuList = subMenuList
    },
    SET_MENUS(state, menus) {
      state.menus = menus
    },
  },
  actions: {
    async getResourceByToken({ commit, getters, dispatch }, params = {}) {
      const { extendRouter, baseName } = params
      commit('SET_GET_IS_PERMISSION', true)
      globalApi
        .getTenantLogo()
        .then((res) => {
          commit('SET_LOGO_OBJ', res.data || {})
        })
        .catch(() => {
          commit('SET_LOGO_OBJ', {})
        })

      return new Promise((resolve, reject) => {
        globalApi
          .getResourceByTokenV2(params)
          .then(async (res) => {
            const allResource = ['tenant_finance_costcenter']
            function copy(data) {
              return data.map((item) => {
                const result = {
                  id: item.id,
                  resourceName: item.name,
                  resourceKey: item.resourceKey,
                  resourceType: item.type,
                }
                if (item.subList && item.subList.length > 0) {
                  result.subList = copy(item.subList || [])
                }
                if (item.rootResourceKey) {
                  result.rootResourceKey = item.rootResourceKey
                }
                if (
                  item.resourceKey &&
                  !allResource.includes(item.resourceKey)
                ) {
                  allResource.push(item.resourceKey)
                }
                return result
              })
            }
            commit('SET_ALLRESOURCE', allResource)
            let resData = copy(res?.data || [])
            // 模拟插入信息

            const { globalFilter = false, globalFilterRes = {} } = params
            const blackList = globalFilterRes.blackList || []
            if (globalFilter === true && blackList.length > 0) {
              resData = filterByBlackList(resData, blackList.map((o) => o.id))
            }
            const adminRoutes = [
              '2019nCoVLoveListCfg',
              'activitylist-taskDetail',
            ]
            // 租牌需求前账号可管理全部城市 adCodeList = [], 租牌需求上线全部城市用 ALL 值表示，
            // 所以此处做兼容处理，adCodeList.length = 0 或者 adCodeList 包含 ALL 值，及代表是 admin 用户。
            // （服务租户上线时也同样做兼容处理）
            const isAdmin =
              getters.userInfo &&
              (getters.userInfo.adCodeList &&
                (!getters.userInfo.adCodeList.length ||
                  getters.userInfo.adCodeList.includes('ALL')))
            if (!isAdmin && getters.userInfo.userType === 1) {
              resData = filterNoAdminKeys(resData, adminRoutes)
            }
            commit('SET_RESOURCE_LIST', resData) // 缓存资源权限
            const { filterRouter, navMenu } = await getMenuFun({
              platformName: baseName, // 子平台的resourceKey
              routers: extendRouter, // 本地路由表
              resourceList: resData, // 服务返回的权限树数据
              allResource,
              request,
            })
            if (!navMenu || !navMenu.length) {
              Message.warning('当前账号无资源权限访问，请联系管理员！')
              dispatch('FedLogOut')
              reject('无权限访问')
            }

            let pathname = null
            const { pathnameList } = getPlatformRole(resData, baseName)
            pathname = pathnameList
            const menus = {}
            getMenus(resData, menus)
            commit('SET_MENUS', menus)
            commit('SET_NAV_MENU', navMenu)
            commit('SET_PLATFORM', pathname)
            commit('SET_ROUTERS', filterRouter)
            commit('SET_GET_IS_PERMISSION', false)
            try {
              // checkRouter('ops', extendRouter, resData)
            } catch (e) {
              console.log(e)
            }
            resolve(res)
          })
          .catch((err) => {
            commit('SET_GET_IS_PERMISSION', false)
            reject(err)
          })
      })
    },
    // 变更二级菜单
    async changeMenu({ commit, state }, { platformName, extendRouter } = {}) {
      const flatResourceList = flatFun(state.resourceList)
      const obj = {
        routers: deepCopy1(extendRouter, flatResourceList, state.allResource),
        platformName,
        resourceList: state.resourceList,
      }
      const menuList = dynamicRoute.getMenuList(obj)
      commit('SET_DYNAMIC_ROUTE', menuList || [])
    },
  },
}
/**
 * 根据云控资源黑名单过滤资源数据
 * @param {*} data
 * @param {*} blackIds
 */
function filterByBlackList(data = [], blackIds = []) {
  let filterRes = data
  filterRes = filterRes.filter((o) => {
    const { id, subList = [] } = o
    if (!blackIds.includes(id)) {
      if (subList && subList.length) {
        o.subList = filterByBlackList(subList, blackIds)
      }
      return true
    }
    return false
  })
  return filterRes
}
// 获取平台权限 & 当前平台资源
function getPlatformRole(roles, platformName) {
  const roleList = [...roles]
  let role = []
  const pathnameList = []
  for (const i in roleList) {
    if (roleList[i].resourceKey === platformName) {
      // 当前平台的资源
      role = roleList[i].subList
    }
    pathnameList.push(roleList[i].resourceKey) // 平台权限集合
  }
  return { role, pathnameList }
}
// 过滤非全部城市的resourceKey
function filterNoAdminKeys(data = [], blackKeys = []) {
  let filterRes = data
  filterRes = filterRes.filter((o) => {
    const { resourceKey, subList = [] } = o
    if (!blackKeys.includes(resourceKey)) {
      if (subList && subList.length) {
        o.subList = filterNoAdminKeys(subList, blackKeys)
      }
      return true
    }
    return false
  })
  return filterRes
}

async function getMenuFun({ routers, resourceList, allResource }) {
  const filterRouter = deepCopy1(routers, flatFun(resourceList), allResource)
  const flatResourceList = flatFun(resourceList) // 平铺后的资源
  const addAttrRouter = addAttrFun(filterRouter, flatResourceList)
  const resNavMenu = resourceList
    .filter((item) => item.resourceType === 3)
    .map((item) => {
      const key = item.resourceKey
      return {
        name: item.resourceName,
        key: item.resourceKey,
        icon: key,
        hoverIcon: `${key}_hover`,
        activeIcon: `${key}_active`,
      }
    })
  // 过滤掉本地路由没有的一级菜单
  const navMenu = resNavMenu.filter((item) => {
    return routers.some((per) => per.name === item.key)
  })
  // 一级路由顺序和服务返回一级资源顺序一致
  const oneLevelSort = routersSort(addAttrRouter, navMenu)
  return {
    filterRouter: oneLevelSort,
    navMenu,
  }
}
// extendRouter flatResource allResource
function deepCopy1(routes, flatResource = [], allResource = []) {
  return routes.reduce((pre, route) => {
    if (allResource.includes(route.name)) {
      const child =
        route &&
        route.children &&
        deepCopy1(route.children, flatResource || [], allResource)
      const obj = {
        ...route,
        children: child,
      }
      pre.push(obj)
    } else if (route.noPermission) {
      pre.push(route)
    }
    return pre
  }, [])
}

function getMenus(resourceList, result = {}, level = []) {
  resourceList.forEach((resource) => {
    if (!result[resource.resourceKey] && level.length) {
      result[resource.resourceKey] = [...level]
    }
    if (resource.subList && resource.subList.length) {
      getMenus(resource.subList, result, [...level, resource.resourceKey])
    }
  })
}

function addAttrFun(menuList, flatData) {
  return menuList.reduce((all, cur) => {
    const someOne = flatData.find((item) => item.resourceKey === cur.name)
    let obj = {}
    const child = cur.children && addAttrFun(cur.children, flatData)
    obj = {
      ...cur,
      children: child,
    }
    if (someOne && someOne.rootResourceKey) {
      obj.meta.rootResourceKey = someOne.rootResourceKey
    }
    if (someOne && someOne.resourceName !== cur.meta.title) {
      obj.meta.resourceName = someOne.resourceName
    }
    all.push(obj)
    return all
  }, [])
}
// 一级路由排序
function routersSort(addAttrRouter = [], navMenu = []) {
  const emptyAr = new Array(addAttrRouter.length)
  navMenu.forEach((item, index) => {
    const someOne = addAttrRouter.find((j) => j.name === item.key)
    if (someOne) {
      emptyAr[index] = someOne
    }
  })
  return emptyAr
}
export default permission
